import React, { useState } from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

import { useTranslation } from "react-i18next";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import EventFinished from "src/components/EventFinished";

const InstaWin2024 = () => {
  const [viewBtn, setViewBtn] = useState(false);
  const { t, i18n } = useTranslation();
  const responsiveBgImage = useResponsiveImageUrl(
    "promotions/instawin-background.jpg"
  );

  return (
    <PromoDetailDiv bgImage={responsiveBgImage}>
      <EventFinished scheduleKeyName="instaWin" eventType="promotion" />
      <div>
        <ResponsiveImage
          src={`promotions/instawin_logo_${i18n.language}.png`}
          alt={t("egd.instawin.hero.title")}
        />
        <div>
          <div>
            <h1>{t("egd.instawin.hero.title")}</h1>
            <p>{t("egd.instawin.hero.subtitle")}</p>
            <h2>{t("egd.instawin.hero.reward")}</h2>
          </div>
        </div>
      </div>
      <div>
        <ReactMarkdown>{t("egd.instawin.content.paragraph1")}</ReactMarkdown>
        <ReactMarkdown>{t("egd.instawin.content.paragraph2")}</ReactMarkdown>
        <ReactMarkdown>{t("egd.instawin.content.paragraph3")}</ReactMarkdown>
        <ContentSectionLink
          href="https://www.instagram.com/playgroundyul/"
          target="_blank"
        >
          <div>
            <span>{t("egd.instawin.content.buttonText")}</span>
          </div>
        </ContentSectionLink>
        <button onClick={() => setViewBtn(!viewBtn)}>
          {t("egd.instawin.content.termsButton")}
          <span></span>
        </button>
        <div className={viewBtn === true ? "ul-active" : undefined}>
          <ul>
            {t("egd.instawin.content.terms", { returnObjects: true }).map(
              (term, index) => (
                <li key={index}>{term}</li>
              )
            )}
          </ul>
        </div>
      </div>
    </PromoDetailDiv>
  );
};
const PromoDetailDiv = styled.div`
  height: fit-content;
  width: 100%;
  position: relative;
  background: #e6e6e6;
  & > div:first-child {
    padding: 100px 0px 0;
    background: url(${(props) => props.bgImage}) 0% 100% fixed no-repeat;
    z-index: 0;
    height: auto;
    overflow: hidden;
    text-align: center;
    position: relative;
    top: 0;
    background-size: cover;
    & > img:first-child {
      max-width: 800px;
      width: 100%;
      height: auto;
      margin: 0 auto;
      object-fit: contain;
    }
    & > div:nth-child(2) {
      background: rgba(0, 0, 0, 0.3);
      height: fit-content;
      width: 100%;
      padding: 20px;
      text-align: center;
      float: left;
      & > div {
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        height: fit-content;
        & > p {
          font-size: 28px;
          line-height: 30px;
          color: #f1f1f1;
          margin: 0 0 10px;
        }
        & > h1 {
          color: var(--white);
          font-weight: 900;
        }
        & > h2 {
          font-size: 32px;
          line-height: 40px;
          color: #fff;
          font-weight: 700;
          margin: 0px;
        }
      }
    }
  }
  & > div:nth-child(2) {
    max-width: 1440px;
    height: fit-content;
    width: 100%;
    margin: 40px auto;
    padding: 40px;
    padding-bottom: 20px;
    background: #fff;
    & > p {
      line-height: 30px;
      font-size: 18px;
      text-align: left;
      color: #555;
      margin: 0 0 10px;
      padding: 0px 15px;
      & > strong {
        font-weight: 700;
      }
    }
    & > button {
      width: 100%;
      max-width: 300px;
      border: none;
      height: 40px;
      background-color: #ddd;
      outline: 0;
      color: var(--black);
      margin: 20px 0;
      border-radius: 0;
      padding: 0;
      & > span {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 5px;
        vertical-align: middle;
        border-top: 4px dashed;
        border-top: 4px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
      }
    }
    & > div:last-child {
      max-height: 0px;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out;
      & > ul {
        padding-left: 20px;
        margin: 40px 0 60px 50px;
        list-style-type: disc;
        & > li {
          padding: 5px;
          font-size: 14px;
          color: #555;
        }
      }
      &.ul-active {
        max-height: 1050px;
      }
    }
  }
  @media screen and (min-width: 992px) {
    /* start of desktop styles */
  }
  @media screen and (max-width: 991px) {
    /* start of phone styles */
    & > div:first-child {
      background: url(${(props) => props.bgImage}) 50% 50% cover no-repeat;
      max-height: 684px;
      & > div:nth-child(2) {
        padding: 40px 20px;
        & > div {
          & > h2 {
            font-size: 26px;
            line-height: 38px;
          }
        }
      }
    }
    & > div:nth-child(2) {
      padding: 20px;
      text-align: center;
      & > button {
        margin: 20px auto 20px auto;
        margin-bottom: 0px;
      }
      & > div:last-child {
        & > ul {
          padding-left: 20px;
          margin: 20px;
          list-style-type: disc;
          & > li {
            text-align: left;
            padding: 5px;
            font-size: 14px;
            color: #555;
          }
        }
      }
    }
  }
`;
const ContentSectionLink = styled.a`
  line-height: 29px;
  height: 50px;
  text-align: center;
  display: block;
  max-width: 300px;
  width: 100%;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: all 0.5s;
  position: relative;
  border-radius: 5px;
  padding: 10px 10px;
  margin: 20px auto;
  font-weight: 700;
  font-size: 20px;
  color: var(--white);
  &:hover {
    color: #d83692;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: all 0.5s;
    color: var(--white);
    background: #d83692;
    border-radius: 5px;
  }
  &:hover::before {
    opacity: 0;
    transform: scale(0.5, 0.5);
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    transition: all 0.5s;
    border: 2px solid #d83692;
    transform: scale(1.2);
    border-radius: 5px;
  }
  &:hover::after {
    opacity: 1;
    transform: scale(1, 1);
  }
`;
export default InstaWin2024;
